module.exports = __webpack_public_path__ + "img/1440.59cca622.jpg";